<!-- ── Toolbar: search + new ─────────────────────────────────────────────── -->
<div class="list-categories__toolbar">
  <ui-form-field
    [formControl]="searchControl"
    [prefixIcon]="'search'"
    [placeholder]="'common.search' | translate"
    class="list-categories__search">
  </ui-form-field>
  <div class="list-categories__toolbar-actions">
    <!-- Bulk actions for the current selection live in the floating
         ui-bulk-actions-bar at the bottom of the table, not here. -->
    <ui-button
      *appHasPermission="{ module: 'product', action: 'create' }"
      type="primary"
      icon="plus-cc"
      iconSize="large"
      [label]="('common.new' | translate) + ' ' + ('inventory.category' | translate)"
      (click)="openCategorie()">
    </ui-button>
  </div>
</div>

<!-- ── Table ─────────────────────────────────────────────────────────────── -->
<div class="list-categories__table" [class.list-categories__table--with-bulk-bar]="selection.hasSelection">
  <div class="list-categories__table-scroll">

    <!-- Header -->
    <div class="list-categories__table-header">
      <div class="list-categories__table-cell list-categories__table-cell--checkbox" (click)="$event.stopPropagation()">
        <ui-checkbox
          [checked]="selection.isAllSelected"
          [indeterminate]="selection.isPartialSelected"
          [ariaLabel]="'common.select_all' | translate"
          (changed)="selection.toggleAll($event.checked)">
        </ui-checkbox>
      </div>
      <div class="list-categories__table-cell">{{ 'common.image' | translate }}</div>
      <div class="list-categories__table-cell">{{ 'common.name' | translate }}</div>
      <div class="list-categories__table-cell">{{ 'common.code' | translate }}</div>
      <div class="list-categories__table-cell">{{ 'common.description' | translate }}</div>
      <div class="list-categories__table-cell">{{ 'common.total_products' | translate }}</div>
      <div class="list-categories__table-cell">{{ 'Categories.category_children' | translate }}</div>
    </div>

    <!-- Loading state -->
    <div class="list-categories__loading" *ngIf="isAppLoading$ | async">
      <div class="list-categories__loading-spinner"></div>
    </div>

    <!-- Rows -->
    <ng-container *ngIf="!(isAppLoading$ | async) && (categories$ | async) as categories">
      <ng-container *ngIf="categories.length > 0">
        <div *ngFor="let category of categories"
          class="list-categories__table-row"
          (click)="openCategorie(category)">
          <div class="list-categories__table-cell list-categories__table-cell--checkbox" (click)="$event.stopPropagation()">
            <ui-checkbox
              [checked]="selection.isSelected(category.id)"
              [ariaLabel]="category.name"
              (changed)="selection.toggleOne(category.id, $event.checked, $event)">
            </ui-checkbox>
          </div>
          <div class="list-categories__table-cell">
            <img *ngIf="category.image" class="list-categories__thumb" [src]="getImage(category.image)" alt="">
            <img *ngIf="!category.image" class="list-categories__thumb list-categories__thumb--placeholder" src="assets/icones/default-image-product.svg" alt="">
          </div>
          <div class="list-categories__table-cell list-categories__table-cell--strong">{{ category.name }}</div>
          <div class="list-categories__table-cell list-categories__table-cell--strong">{{ category.code ? category.code : '--' }}</div>
          <div class="list-categories__table-cell list-categories__table-cell--description">{{ category?.description || '--' }}</div>
          <div class="list-categories__table-cell">{{ category.total_product ?? 0 }}</div>
          <div class="list-categories__table-cell list-categories__table-cell--sub">
            <span *ngFor="let sub of category.sub_categories" class="list-categories__sub-badge">{{ sub.name }}</span>
            <span *ngIf="!category.sub_categories?.length">--</span>
          </div>
        </div>
      </ng-container>

      <!-- Empty state -->
      <div *ngIf="categories.length === 0" class="list-categories__empty">
        <ng-container *ngIf="!key">
          <img class="list-categories__empty-illustration" src="assets/icones/no-categories.svg" alt="">
          <h3>{{ 'Categories.no_categories' | translate }}</h3>
        </ng-container>
        <ng-container *ngIf="key">
          <img class="list-categories__empty-illustration" src="assets/icones/no-result-search.svg" alt="">
          <h3>{{ 'Categories.no_data_search' | translate }}</h3>
        </ng-container>
      </div>
    </ng-container>
  </div>

  <!-- ─────────────────────────────────────────────────────────────────────── -->
  <!-- Bulk actions for the current selection. Floats centred at the bottom of -->
  <!-- the table so selecting rows never reflows the toolbar above it.         -->
  <!-- ─────────────────────────────────────────────────────────────────────── -->
  <ui-bulk-actions-bar
    *ngIf="selection.hasSelection"
    [count]="selection.count"
    (cleared)="selection.clear()">
    <button
      *appHasPermission="{ module: 'product', action: 'delete' }"
      class="ui-bulk-action ui-bulk-action--danger"
      (click)="bulkDelete()">
      <ui-icon name="Trash2" size="medium"></ui-icon>
      <span>{{ 'common.delete' | translate }}</span>
    </button>
  </ui-bulk-actions-bar>
  <!-- ── END BULK ACTIONS BAR ─────────────────────────────────────────────── -->

  <!-- Pagination lives inside the bordered container, below the rows -->
  <app-pagination *ngIf="((categories$ | async)?.length ?? 0) > 0"
    class="list-categories__pagination"
    [pagination]="pagination$ | async"
    (toPageEvent)="toPage($event)">
  </app-pagination>
</div>
